import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Card, CardBody, Spinner } from 'reactstrap';
import { Package, AlertTriangle, XCircle, Clock, DollarSign } from 'react-feather';
import { useTranslation } from 'react-i18next'; // Tambahan import

const SummaryCards = ({ summary, loading }) => {
  const { t } = useTranslation(); // Inisialisasi hook translation

  const formatCurrency = (value) => {
    const num = parseFloat(value) || 0;
    return `Rp ${num.toLocaleString('id-ID')}`;
  };

  if (loading) {
    return (
      <Row className="g-3">
        <Col xs={12} className="text-center py-4">
          <Spinner color="primary" />
        </Col>
      </Row>
    );
  }

  const data = summary || {};

  const cards = [
    { 
      title: t('Total Item'), 
      value: data.total_items || 0, 
      Icon: Package, 
      color: '#3b82f6', 
      bg: '#eff6ff' 
    },
    { 
      title: t('Nilai Stok'), 
      value: formatCurrency(data.total_stock_value), 
      Icon: DollarSign, 
      color: '#10b981', 
      bg: '#ecfdf5' 
    },
    { 
      title: t('Stok Rendah'), 
      value: data.low_stock_count || 0, 
      Icon: AlertTriangle, 
      color: '#f59e0b', 
      bg: '#fffbeb' 
    },
    { 
      title: t('Stok Habis'), 
      value: data.out_of_stock_count || 0, 
      Icon: XCircle, 
      color: '#ef4444', 
      bg: '#fef2f2' 
    },
    { 
      title: t('Hampir Expired'), 
      value: data.near_expired_count || 0, 
      Icon: Clock, 
      color: '#8b5cf6', 
      bg: '#f5f3ff' 
    },
  ];

  return (
    <Row className="g-3">
      {cards.map((card) => {
        const { Icon, title, value, color, bg } = card;
        return (
          <Col key={title} xs={6} sm={4} md={4} lg={2} xl={2} style={{ flex: '1 0 18%' }}>
            <Card className="shadow-sm border-0 h-100" style={{ borderRadius: '12px' }}>
              <CardBody className="p-3 d-flex align-items-center gap-3">
                <div
                  className="d-flex align-items-center justify-content-center rounded flex-shrink-0"
                  style={{ width: '42px', height: '42px', backgroundColor: bg, color }}
                >
                  <Icon size={20} />
                </div>
                <div className="min-w-0">
                  <div className="text-muted text-truncate" style={{ fontSize: '11px', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                    {title}
                  </div>
                  <h5 className="fw-bold mb-0 text-truncate" style={{ color, fontSize: '18px' }}>
                    {value}
                  </h5>
                </div>
              </CardBody>
            </Card>
          </Col>
        );
      })}
    </Row>
  );
};

SummaryCards.propTypes = {
  summary: PropTypes.object,
  loading: PropTypes.bool,
};

SummaryCards.defaultProps = {
  summary: null,
  loading: false,
};

export default SummaryCards;